import { render, staticRenderFns } from "./PaisView.vue?vue&type=template&id=e66bceea&scoped=true"
import script from "./PaisView.vue?vue&type=script&lang=js"
export * from "./PaisView.vue?vue&type=script&lang=js"
import style0 from "./PaisView.vue?vue&type=style&index=0&id=e66bceea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66bceea",
  null
  
)

export default component.exports